import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "form-custom ml-4 deviceinfo-tab__content" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = { class: "fw-bold mb-2" }
const _hoisted_4 = { class: "p-field-label mb-1" }
const _hoisted_5 = { class: "p-field-label mb-1" }
const _hoisted_6 = {
  key: 0,
  class: "w-50",
  style: {"background-color":"var(--color-borders)"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.gatesDevicesInfo, (devicesInfo, gateid, index) => {
      return (_openBlock(), _createBlock(_Fragment, { key: index }, [
        _createVNode("div", _hoisted_2, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(devicesInfo, (device, i) => {
            return (_openBlock(), _createBlock("div", {
              key: i,
              class: "device-info"
            }, [
              _createVNode("label", _hoisted_3, _toDisplayString(device.name), 1),
              _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("AppResource.FirmwareVersionUpper")), 1),
              _createVNode("label", {
                class: ["mb-2", _ctx.fieldHasValue(device.firmwareVersion) ? 'fw-bold' : 'text-gray no-data']
              }, _toDisplayString(_ctx.firmwareVersion(device.firmwareVersion)), 3),
              _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("AppResourceEP.MacAddress")), 1),
              _createVNode("label", {
                class: ["mb-2", _ctx.fieldHasValue(device.macAddress) ? 'fw-bold' : 'text-gray no-data']
              }, _toDisplayString(_ctx.macAddress(device.macAddress)), 3)
            ]))
          }), 128))
        ]),
        (!_ctx.isLast(index))
          ? (_openBlock(), _createBlock("hr", _hoisted_6))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}